// components/Testimonials.jsx

import { motion } from "framer-motion";
import { fadeIn, staggerContainer, textVariant } from "../utils/motion"; // Vous pouvez créer ces animations (voir étape 3)
import { useTranslation } from "react-i18next"


const Testimonials = () => {
  const { t } = useTranslation();
  const testimonials = [
  {
    name: "Amadou L.",
    role: t("testi"),
    text: t("testi.text"),
    avatar: require("../images/pexels-gladsonfx-111738.jpg"),
  },
  {
    name: "Amine B.",
    role: t("testi1"),
    text: t("testi1.text"),
    avatar: require("../images/pexels-public-domain-pictures-41539.jpg"),
  },
  {
    name: "Claire T.",
    role: t("testi2"),
    text: t("testi2.text"),
    avatar: require("../images/Capture d’écran 2025-08-14 181708.png"),
  },
];
  return (
    <motion.section
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.25 }}
      variants={staggerContainer}
      className="bg-white dark:bg-[#706F6F] py-16 px-4"
    >
      <div className="max-w-6xl mx-auto text-center">
        <motion.h2
          variants={textVariant(0.1)}
          className="text-4xl font-bold text-[#42AB3F] mb-12"
        >
          {t("testifirst")}
        </motion.h2>

        <motion.div
          variants={staggerContainer}
          className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3"
        >
          {testimonials.map((t, index) => (
            <motion.div
              key={index}
              variants={fadeIn("up", "spring", index * 0.2, 0.75)}
              className="bg-gray-50 dark:bg-white p-6 rounded-2xl shadow-md flex flex-col items-center text-center 
              hover:scale-105 transition-transform duration-300"
              whileHover={{
                scale: 1.05,
                boxShadow: "0px 10px 20px rgba(0,0,0,0.1)",
              }}
            >
              <motion.img
                src={t.avatar}
                alt={t.name}
                className="w-16 h-16 rounded-full mb-4 object-cover"
                whileHover={{ scale: 1.1 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              />
              <motion.p className="text-gray-700 dark:text-black italic mb-4">
                "{t.text}"
              </motion.p>
              <div className="text-gray-800 dark:text-black font-semibold">
                {t.name}
              </div>
              <div className="text-gray-500 dark:text-gray-600 text-sm">
                {t.role}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Testimonials;
